import React from "react"
import {BrowserRouter, Routes, Route, Navigate} from "react-router-dom"
import {useAuthContext} from "@/hooks/useAuthContext"
import Login from "@/pages/auth/Login"
import Home from "@/pages/home/Home"
import Users from "@/pages/usuarios/Usuarios"
import Signup from "@/pages/auth/Signup"
import AddWorkerAdmin from "@/pages/usuarios/AddWorkerAdmin"
import CreateAccount from "@/pages/auth/CreateAccount"
import PropertiesPage from "@/pages/inmuebles/PropertiesPage"
import CondosFeed from "@/pages/condominios/CondosFeed"
import Profile from "@/pages/perfil/Profile"
import PropertyPage from "@/pages/inmuebles/PropertyPage"
import CondoPage from "@/pages/condominios/CondoPage"
import AddProperty from "@/pages/inmuebles/AddInmueble"
import EditInmueble from "@/pages/inmuebles/EditInmueble"
import CreateCondo from "@/pages/condominios/CreateCondo"
import UpdateCondo from "@/pages/condominios/UpdateCondo"
import Temporadas from "@/pages/temporadas/Temporadas"
import EditPhotos from "@/pages/inmuebles/EditPhotos"
import EditCondoPhotos from "@/pages/condominios/UpdateCondoImages"
import EditFiles from "@/pages/files/EditFiles"
import Asociates from "@/pages/asociados/Associates"
import ExcelViewInm from "@/pages/inmuebles/ExcelViewInm"
import CondosSpreadsheetView from "@/pages/condominios/SpreadsheetView"
import ResetPassword from "./pages/auth/ResetPassword"
import {clearCache} from "./utils"

function App() {
   const {user, authIsReady, isWorker} = useAuthContext()

   // Clear cache to get latest data
   React.useEffect(() => {
      clearCache()
   }, [])

   return (
      <div className="App font-sans">
         {authIsReady ? (
            <>
               <BrowserRouter>
                  <Routes>
                     <Route path="/" element={user ? <Home /> : <Navigate to="/login" />} />
                     <Route
                        path="/inmuebles"
                        element={user ? <PropertiesPage /> : <Navigate to="/login" />}
                     />
                     <Route
                        path="/inmuebles/:id"
                        element={user ? <PropertyPage /> : <Navigate to="/login" />}
                     />
                     <Route
                        path="/inmuebles/:id/renta"
                        element={user ? <PropertyPage /> : <Navigate to="/login" />}
                     />
                     <Route
                        path="/inmuebles/:id/venta"
                        element={user ? <PropertyPage /> : <Navigate to="/login" />}
                     />
                     <Route
                        path="/condominios/:id"
                        element={user ? <CondoPage /> : <Navigate to="/login" />}
                     />
                     <Route
                        path="/condominios"
                        element={user ? <CondosFeed /> : <Navigate to="/login" />}
                     />
                     <Route
                        path="/perfil"
                        element={user ? <Profile /> : <Navigate to="/login" />}
                     />
                     <Route path="/login" element={!user ? <Login /> : <Navigate to="/" />} />
                     <Route path="/signup" element={!user ? <Signup /> : <Navigate to="/" />} />
                     <Route
                        path="/crearCuenta"
                        element={isWorker && !user ? <CreateAccount /> : <Navigate to="/login" />}
                     />
                     <Route
                        path="reset-password"
                        element={!user ? <ResetPassword /> : <Navigate to="/" />}
                     />
                     <Route
                        path="/usuarios"
                        element={user ? <Users /> : <Navigate to="/login" />}
                     />
                     <Route
                        path="/usuarios/agregar"
                        element={
                           user ? (
                              user.admin ? (
                                 <AddWorkerAdmin />
                              ) : (
                                 <Admin403 />
                              )
                           ) : (
                              <Navigate to="/login" />
                           )
                        }
                     />
                     <Route
                        path="/inmuebles/nuevo"
                        element={
                           user ? (
                              user.admin ? (
                                 <AddProperty />
                              ) : (
                                 <Admin403 />
                              )
                           ) : (
                              <Navigate to="/login" />
                           )
                        }
                     />
                     <Route
                        path="/inmuebles/editInmueble/:id"
                        element={
                           user ? (
                              user.admin ? (
                                 <EditInmueble />
                              ) : (
                                 <Admin403 />
                              )
                           ) : (
                              <Navigate to="/login" />
                           )
                        }
                     />
                     <Route
                        path="/inmuebles/editPhotos/:id"
                        element={
                           user ? (
                              user.admin ? (
                                 <EditPhotos />
                              ) : (
                                 <Admin403 />
                              )
                           ) : (
                              <Navigate to="/login" />
                           )
                        }
                     />
                     <Route
                        path="/inmuebles/editFiles/:id"
                        element={
                           user ? (
                              user.admin ? (
                                 <EditFiles />
                              ) : (
                                 <Admin403 />
                              )
                           ) : (
                              <Navigate to="/login" />
                           )
                        }
                     />
                     <Route
                        path="/condominios/nuevo"
                        element={
                           user ? (
                              user.admin ? (
                                 <CreateCondo />
                              ) : (
                                 <Admin403 />
                              )
                           ) : (
                              <Navigate to="/login" />
                           )
                        }
                     />
                     <Route
                        path="/condominios/editCondominio/:id"
                        element={
                           user ? (
                              user.admin ? (
                                 <UpdateCondo />
                              ) : (
                                 <Admin403 />
                              )
                           ) : (
                              <Navigate to="/login" />
                           )
                        }
                     />
                     <Route
                        path="/condominios/editPhotos/:id"
                        element={
                           user ? (
                              user.admin ? (
                                 <EditCondoPhotos />
                              ) : (
                                 <Admin403 />
                              )
                           ) : (
                              <Navigate to="/login" />
                           )
                        }
                     />
                     <Route
                        path="/condominios/editFiles/:id"
                        element={
                           user ? (
                              user.admin ? (
                                 <EditFiles />
                              ) : (
                                 <Admin403 />
                              )
                           ) : (
                              <Navigate to="/login" />
                           )
                        }
                     />
                     <Route
                        path="/temporadas"
                        element={user ? <Temporadas /> : <Navigate to="/login" />}
                     />
                     <Route
                        path="/asociados"
                        element={
                           user ? (
                              user.admin ? (
                                 <AccessGatedPage
                                    type="password"
                                    text="Ingrese la contraseña para acceder a la sección de asociados"
                                 >
                                    <Asociates />
                                 </AccessGatedPage>
                              ) : (
                                 <Admin403 />
                              )
                           ) : (
                              <Navigate to="/login" />
                           )
                        }
                     />
                     <Route
                        path="/inmuebles/excelView"
                        element={
                           user ? (
                              user.admin ? (
                                 <ExcelViewInm />
                              ) : (
                                 <Admin403 />
                              )
                           ) : (
                              <Navigate to="/login" />
                           )
                        }
                     />
                     <Route
                        path="/condominios/excelView"
                        element={
                           user ? (
                              user.admin ? (
                                 <CondosSpreadsheetView />
                              ) : (
                                 <Admin403 />
                              )
                           ) : (
                              <Navigate to="/login" />
                           )
                        }
                     />
                  </Routes>
               </BrowserRouter>
            </>
         ) : (
            <FullScreenLoader />
         )}
      </div>
   )
}

export default App

// Full screen login component
import {useEffect, useState} from "react"
import Admin403 from "./pages/auth/Admin403"
import AccessGatedPage from "./components/gated-pages/access"

function FullScreenLoader() {
   const [message, setMessage] = useState("Autenticando...")
   const [error, setError] = useState(false)

   useEffect(() => {
      const timer1 = setTimeout(() => {
         setMessage("El servidor se encontraba en estado de reposo, espere un momento...")
      }, 6000)

      const timer2 = setTimeout(() => {
         setMessage("El servidor está tardando más de lo esperado, espere un momento...")
      }, 13000)

      const timer3 = setTimeout(() => {
         setMessage(
            "Ocurrió un error inesperado, reinicie la página o revise los logs de la consola para mayor información. Si el error persiste, contacte a soporte técnico o al administrador.",
         )
         setError(true)
      }, 25000)

      return () => {
         clearTimeout(timer1)
         clearTimeout(timer2)
         clearTimeout(timer3)
      }
   }, [])
   return (
      <div className="h-[100vh] flex flex-col justify-center items-center bg-blue text-white gap-8">
         <img
            src="/logos/casas_diamante_blanco.png"
            alt="Casas Diamante Logo blanco"
            width={200}
            height={200}
            className={!error ? "animate-pulse" : ""}
         />
         <p className={`text-lg md:mx-[30%] mx-4 text-center ${!error && "animate-pulse"}`}>
            {message}
         </p>
      </div>
   )
}
